import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

/**
This service won't upload any avatars. It's just for communicating to the interested
parties the new avatar url after an upload.
*/
@Injectable()
export class UserAvatarService {
 
  // Observable source
  private avatarSource = new Subject<string>();
 
  // Observable stream
  avatar$ = this.avatarSource.asObservable();
 
  // Service message commands
  setAvatar(text: string) {
    // Force image reload adding a random suffix
    this.avatarSource.next(text+'?dummy='+Math.floor(Math.random()*1000000));
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/user-avatar-service.ts